import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const Breadcrumb = ({ items }) => {
  return (
    <nav aria-label="Breadcrumb" style={{
      padding: '20px 0',
      fontSize: '0.95rem'
    }}>
      <ol style={{
        display: 'flex',
        alignItems: 'center',
        listStyle: 'none',
        padding: 0,
        margin: 0,
        flexWrap: 'wrap',
        gap: '8px'
      }}>
        {items.map((item, index) => (
          <li key={index} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            {index > 0 && <ChevronRight size={16} color="rgba(255, 255, 255, 0.7)" />}
            {item.link ? (
              <Link to={item.link} style={{
                color: 'white',
                textDecoration: 'none',
                fontWeight: 500,
                opacity: 0.9,
                transition: 'opacity 0.3s ease'
              }}>
                {item.label}
              </Link>
            ) : (
              <span style={{
                color: 'var(--gold-primary)',
                fontWeight: 600
              }}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;